export default interface PolylineOptions {
  color?: number;
  opacity?: number;
  width?: number;
  useNetwork?: Boolean;
}
